import {
  Check,
  Download,
  FileText,
  RotateCcw,
  ShieldCheck,
} from "lucide-react";

import type { ProcessingJobDto } from "@wendo/contracts";

export function ResultDownloads({
  job,
  downloadingAssetId,
  onDownload,
  onReset,
}: {
  readonly job: ProcessingJobDto;
  readonly downloadingAssetId: string | null;
  readonly onDownload: (assetId: string) => void;
  readonly onReset: () => void;
}) {
  const original = job.inputAssets[0];
  const output = job.outputAsset;
  return (
    <section className="result-panel" aria-live="polite">
      <span className="success-orb">
        <Check size={45} strokeWidth={2.8} />
      </span>
      <h2>转换成功！</h2>
      <p>原 PDF 和 Word 结果仅在当前页面会话中可用</p>
      <div className="download-grid">
        {output !== null ? (
          <DownloadCard
            kind="word"
            title={output.originalName}
            subtitle="Word 文件"
            buttonLabel="下载 Word"
            busy={downloadingAssetId === output.id}
            onDownload={() => onDownload(output.id)}
          />
        ) : null}
        {original !== undefined ? (
          <DownloadCard
            kind="pdf"
            title={original.originalName}
            subtitle="原 PDF 文件"
            buttonLabel="下载原 PDF"
            busy={downloadingAssetId === original.id}
            onDownload={() => onDownload(original.id)}
          />
        ) : null}
      </div>
      <button className="secondary-action" type="button" onClick={onReset}>
        <RotateCcw size={18} />
        重新转换
      </button>
      <p className="result-privacy">
        <ShieldCheck size={18} />
        关闭页面后，两个文件都会被清理
      </p>
    </section>
  );
}

function DownloadCard({
  kind,
  title,
  subtitle,
  buttonLabel,
  busy,
  onDownload,
}: {
  readonly kind: "word" | "pdf";
  readonly title: string;
  readonly subtitle: string;
  readonly buttonLabel: string;
  readonly busy: boolean;
  readonly onDownload: () => void;
}) {
  return (
    <article className="download-card">
      <span className={`file-kind-icon ${kind}`}>
        <FileText size={31} />
      </span>
      <span className="file-copy">
        <strong>{title}</strong>
        <small>{subtitle}</small>
      </span>
      <button
        className="download-button"
        type="button"
        onClick={onDownload}
        disabled={busy}
      >
        <Download size={17} />
        {busy ? "下载中…" : buttonLabel}
      </button>
    </article>
  );
}
